import { render, staticRenderFns } from "./ConfigAlertRocketChat.vue?vue&type=template&id=6a42333e&"
import script from "./ConfigAlertRocketChat.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertRocketChat.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAlertRocketChat.vue?vue&type=style&index=0&id=6a42333e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports